import { NavMenuCategory } from '@everlywell/leaves';

import giftGuideImage from '../../images/gift-guide-product-card.png';
import virtualCareVisitImage from '../../images/virtual-care-visit.png';
import { ANALYTICS } from './analytics';

export const FOOD_SENSITIVITY_TEST_SLUGS = [
  'food-sensitivity',
  'food-sensitivity-expansion',
];

export const PRODUCT_SLUGS = {
  FOOD_SENSITIVITY_PKI: 'food-sensitivity',
  FOOD_SENSITIVITY_COMPREHENSIVE: 'food-sensitivity-comprehensive-test',
  WOMENS_HEALTH: 'womens-health-test',
  THYROID: 'thyroid-test',
  COVID: 'covid-19-test',
  COVID_ELLUME: 'covid-ellume-rapid-test',
  COVID_QUIDEL: 'covid-quidel-rapid-test',
  COVID_BD: 'covid-bd-veritor-rapid-test',
};

export const VARIANT_SKUS = {
  COVID: 'covid-19-ew',
  COVID_BD: 'covid-bd-veritor-rapid-test',
};

/**
 * top 5 product IDs in order
 */
export const top5 = [
  PRODUCT_SLUGS.FOOD_SENSITIVITY_PKI,
  PRODUCT_SLUGS.FOOD_SENSITIVITY_COMPREHENSIVE,
  PRODUCT_SLUGS.COVID,
  PRODUCT_SLUGS.WOMENS_HEALTH,
  PRODUCT_SLUGS.THYROID,
];

export const COVID_SLUGS = [
  PRODUCT_SLUGS.COVID,
  PRODUCT_SLUGS.COVID_ELLUME,
  PRODUCT_SLUGS.COVID_QUIDEL,
  PRODUCT_SLUGS.COVID_BD,
];

export const PHONE_NUMBER_NEEDED_SKUS = [VARIANT_SKUS.COVID];

export const GIFT_GUIDE_CATEGORY: NavMenuCategory = {
  displayName: 'Holiday Gift Guide',
  slug: 'gift-guide',
  badge: 'New',
  productLinks: [],
  card: {
    slug: 'gift-guide',
    label: '',
    url: '/gift-guide/',
    tags: ['gift-guide'],
    description:
      'Give the gift of health this holiday season with curated picks for all the loved ones on your list.',
    image: {
      alt: 'Holiday Gift Guide Page',
      src: giftGuideImage,
    },
    cta: 'Explore Holiday Gift Guide',
  },
};

export const TELEHEALTH_CONSULT_CATEGORY: NavMenuCategory = {
  displayName: 'Talk to a Clinician',
  slug: 'virtual-care-visit',
  badge: 'New',
  productLinks: [],
  card: {
    slug: 'virtual-care-visit',
    label: '',
    url: '/virtual-care-visit',
    tags: [''],
    description: `
    Meet with a licensed nurse practitioner to help address your symptoms with the right test, prescriptions or lifestyle recommendations. Visits covered by many major insurance plans.
    `,
    image: {
      alt: 'Three phones with an image of the Virtual Care page',
      src: virtualCareVisitImage,
    },
    cta: 'Schedule a visit',
    'data-analytics-event': ANALYTICS.EVENTS.CLICKED_BUTTON,
    'data-analytics-label': 'Side Nav - Talk to a Clinician - Schedule a visit',
  },
};
